import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationGallery } from '../../components/locations/LocationGallery';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function HemlockPage() {
  const location = getLocationById('hemlock');
  if (!location) {
    return <div data-id="element-951">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-952">
      <Header data-id="element-953" />

      <main data-id="element-954">
        <LocationPageHero location={location} data-id="element-955" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-956" />
        {location.galleryImages && location.galleryImages.length > 0 && <LocationGallery images={location.galleryImages} locationName={location.name} data-id="element-957" />}
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-958" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-959" />
      </main>

      <Footer data-id="element-960" />
    </div>;
}